export default __webpack_public_path__ + "static/PLA-5e23f31373494f544db6a771ef8e9a7e.png";